// src/components/pages/NotFound.jsx
import React from 'react';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useUserRights } from '../../context/UserRightsContext';
import { resolveDefaultAppPath } from '../../utils/defaultAppPath';
import { isHarmonateUser as isServerHarmonateUser } from '../../auth/serverIdentity';

const NotFound = () => {
  const navigate = useNavigate();
  const { canAccessMenu } = useUserRights();
  const isHarmonateUser = isServerHarmonateUser();
  
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Typography variant="h1" component="h1" gutterBottom>
            404
          </Typography>
          <Typography variant="h5" component="h2" gutterBottom>
            Page Not Found
          </Typography>
          <Typography sx={{ mt: 2, mb: 4, textAlign: 'center' }}>
            The page you are looking for does not exist or has been moved.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate(resolveDefaultAppPath(canAccessMenu, isHarmonateUser))}
          >
            Continue
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default NotFound;